module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_6005.67e7dd04.png";